import React from 'react';
import './Preventions.css';

import { Heading, Prevention } from '../../../components';
import { preventions } from '../../../constants';

// Import Swiper core and required modules
import { Autoplay } from 'swiper/modules';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';



const Preventions = () => {

  return (
    <section className='preventions'>

      {/* Section heading */}
      <Heading title={'Fire Prevention Tips'} subTitle={'Excellence in Fire Prevention'} />

      <div className='prevention-slider'>

        <Swiper

          // Install Swiper modules
          modules={[Autoplay]} // Enable Pagination & Autoplay
          spaceBetween={10} // Space between slides
          loop={true} // Infinite Looping
          autoplay={{ delay: 4000, disableOnInteraction: false }} // Auto-slide every 4 seconds

          // Responsive Breakpoints
          breakpoints={{
            768: { slidesPerView: 1 }, // 1 slides for tablets
            991: { slidesPerView: 2 }, // 2 slides for larger screens
          }}

        >
          {/* Map over the preventions array to render each prevention tip */}
          {preventions.map((prev) => {

            return (
              <SwiperSlide key={prev.id}>

                <Prevention prev={prev} />

              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
    </section>
  );
}

export default Preventions;